import { Grid, Tab, Tabs, Typography } from '@material-ui/core';
import { FuncaoParticipante, GrupoAcesso, Perfil } from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { LgSpace, MdSpace } from 'm2m.components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import DownloadDocsS3 from "components/docsS3/downloadDocsS3";
import UploadDocsS3 from "components/docsS3/uploadDocsS3";

const UploadArquivos: React.FC = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const tabParam = searchParams.get('tab');
  const tipoParam = searchParams.get('tipo');
  
  const isParticipanteCustodiante = useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Custodiante;
  const isUsuarioMaster = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Master);
  const isUsuarioCadastroOperacoes = useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.CadastroOperacoes;
  const isUsuarioOperacoes = useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isUsuarioCadastroLeitura = useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.CadastroLeitura;
  const isUsuarioOperacoesLeitura = useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.OperacoesLeitura;
  
  const [tabValue, setTabValue] = useState<number>(tabParam ? parseInt(tabParam) : 0);

  return (
    <div style={{ margin: '0 40px 80px 0' }}>
      {(isParticipanteCustodiante ||
        isUsuarioMaster ||
        isUsuarioCadastroOperacoes ||
        isUsuarioOperacoes ||
        isUsuarioCadastroLeitura ||
        isUsuarioOperacoesLeitura) &&
        (
          <>
            <Grid container direction={'row'} alignItems={'center'}>
              <Grid item lg>
                <Typography variant="h1">{'Integração via Arquivo'}</Typography>
              </Grid>
            </Grid>
            <LgSpace />
            <HorizontalAppBar>
              <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
                <Tab label="Download" value={0} />
                <Tab label="Upload" value={1} />
              </Tabs>
            </HorizontalAppBar>
            <MdSpace />
            <div>
              {tabValue === 0 && <DownloadDocsS3 />}
              {tabValue === 1 && <UploadDocsS3 />}
            </div>
          </>
        )}
    </div>
  );
};

export default UploadArquivos;
